import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

// Redux
import { Provider } from "react-redux";
import { store } from "./redux";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
